import saferEval from 'safer-eval'

export function getShortCodeValue(string, data, options = {}){
  if (!string) return ''

  const { returnRawValue } = options || {}
  const stripped = string.replace(/[^\w.]/g, '')
  if (stripped){
    const split = stripped.split('.')

    const value = split.reduce((obj, key) => {
      if (obj[key] === undefined) return {}
      if (obj[key] === null) return {}
      return obj[key]
    }, data)

    if (returnRawValue) return value
    if (typeof value === 'boolean') return value
    if (typeof value === 'object') return ''
    if (!value) return ''

    return typeof value === 'string' ? value : `${value}`
  }

  return ''
}

export function evaluateFunction(string){
  const match = string.match(/`(.+)`/)
  if (match && match[1]){
    const result = saferEval(match[1])
    return result
  }

  return string
}

function replaceTextShortCodes(string, data){
  if (!string) return ''

  const regex = /({{([\w.])+}})/g

  const matches = string.match(regex)
  if (matches){
    let parsedString = string.slice()

    matches.forEach((match) => {
      const value = getShortCodeValue(match, data)
      parsedString = parsedString.replace(match, value)
    })

    return evaluateFunction(parsedString)
  }

  return evaluateFunction(string)
}

export function evaluateCondition(string, operator, value){
  if (operator === 'present') return !!string
  if (operator === 'empty') return !string
  if (operator === 'eq') return string === value
  if (operator === 'unequal') return string !== value
  return false
}

export function validateRenderConditions(conditions, data){
  if (conditions && conditions.length){
    let validConditionCount = 0

    conditions.forEach((condition) => {
      const string = replaceTextShortCodes(condition.string, data)
      const value = replaceTextShortCodes(condition.value, data)

      if (evaluateCondition(string, condition.operator, value)){
        validConditionCount += 1
      }
    })

    return validConditionCount === conditions.length
  }

  return true
}

export default replaceTextShortCodes
